import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  DateTimeService,
  MOMENT_LONG_ABBREVIATED_DATE_FORMAT,
} from 'i2g-ng-utils';

@Pipe({
  name: 'friendlyDate',
})
export class FriendlyDatePipe implements PipeTransform {
  constructor(
    private _dateTimeService: DateTimeService,
    private _translateService: TranslateService
  ) {}

  transform(
    date: string,
    onlyAbsoluteDate: boolean = true,
    minRelativeDays: number = 0,
    maxRelativeDays: number = 0,
    format: string = MOMENT_LONG_ABBREVIATED_DATE_FORMAT
  ): string {
    if (!onlyAbsoluteDate) {
      const daysDifference = this._dateTimeService.calculateNumberOfUnitsFromDate(
        date,
        this._dateTimeService.getDateString(),
        'day',
        'days',
        false
      );

      if (daysDifference === 0) {
        return this._translateService.instant('DATE.TODAY');
      } else if (daysDifference === -1) {
        return this._translateService.instant('DATE.YESTERDAY');
      } else if (daysDifference === 1) {
        return this._translateService.instant('DATE.IN_ONE_DAY');
      } else if (
        (minRelativeDays === null || daysDifference >= minRelativeDays * -1) &&
        daysDifference <= -2
      ) {
        return this._translateService.instant('DATE.N_DAYS_AGO', {
          number: daysDifference * -1,
        });
      } else if (
        daysDifference >= 2 &&
        (maxRelativeDays === null || daysDifference <= maxRelativeDays)
      ) {
        return this._translateService.instant('DATE.IN_N_DAYS', {
          number: daysDifference,
        });
      }
    }

    return this._dateTimeService.formatDate(date || void 0, format);
  }
}
